export default __webpack_public_path__ + "images/1df576c2d3fcc7d9412f5c3dc12de178.svg";